import React, { useEffect, useState } from 'react';
import { ContentContainer, SectionPage, Row, Col, ComponentLoader, Field, Button, RadioButtonList, Select, Heading, pxToRem, tokens, FormHeader } from '@snsw-gel/react';
import { history } from '@starterapp/shared-services/history';
import { getLinkedCard, patchMarketing } from '../../../services/api-services';
import { dataLayer } from '../../../services/gtm-dataLayer';
import styles from './ChangeMarketingDetails.module.scss';
import { languageList } from './languageList'

const ChangeMarketingDetailsPage = () => {
    const [showSpinner, setShowSpinner] = useState('false');
    const [specOffer, setSpecOffer] = useState("");
    const [newsletter, setNewsletter] = useState("");
    const [cardDetails, setCardDetails] = useState({});
    const [hasError, setHasError] = useState(false);
    const [language, setLanguage] = useState("");
    const [pension, setPension] = useState("");
    const [gender, setGender] = useState("");
    const [isAboriginal, setIsAboriginal] = useState("");
    const [show, setShow] = useState(false)

    const loadInitial = () => {
        setShow(false)
        setLanguage("");
        setPension("");
        setGender("");
        setIsAboriginal("");
    }
    const setPreferences = (languageSpokenAtHome, pensionStatus, gender, aboriginalOrTorresStraitIslander) => {

        languageSpokenAtHome ? setLanguage(languageSpokenAtHome + '') : setLanguage("");
        pensionStatus ? setPension(pensionStatus + '') : "";
        pensionStatus === "FULL PENSION" ? setPension("Full Pension") : "";
        gender ? setGender(gender + '') : "";
        aboriginalOrTorresStraitIslander ? setIsAboriginal(aboriginalOrTorresStraitIslander+''):"";
    }

    useEffect(() => {
        setShowSpinner(true);

        const currentUrl = window.location.href;
        const pageName = window.location.href.split('/').pop();
        dataLayer(currentUrl, pageName);

        getLinkedCard(['type', 'marketing', 'personal']).then(response => {
            setCardDetails(response);
            setNewsletter(response.marketingENewsletters + '')
            setShowSpinner(false);

            switch (response.marketingSpecialOffers.toLowerCase()) {
                case "email and mail":
                    setSpecOffer('both');
                    setShow(true);
                    setPreferences(response.languageSpokenAtHome, response.pensionStatus, response.gender, response.aboriginalOrTorresStraitIslander);
                    break;
                case "email":
                case "email only":
                    setSpecOffer('email');
                    setShow(true);
                    setPreferences(response.languageSpokenAtHome, response.pensionStatus, response.gender, response.aboriginalOrTorresStraitIslander);
                    break;
                case "none":
                    setSpecOffer('none');
                    break;
            }
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const onSubmitChange = () => async _ => {

        let response;
        setShowSpinner(true);

        if (specOffer === "none") {
            try {
                response = await patchMarketing(JSON.parse(newsletter), specOffer);
            } catch (ex) { }
            setShowSpinner(false);
        } else {
            try {
                response = await patchMarketing(JSON.parse(newsletter), specOffer, language, pension, gender, isAboriginal);
            } catch (ex) { }
            setShowSpinner(false);

        }
        if (!response._httpStatus || response._httpStatus === 200) {
            sessionStorage.setItem('ConfirmationResponse', 'marketing');
            sessionStorage.setItem('CardTypeText', cardDetails.cardType);
            history.push('/changeDetailsConfirmation');
            window.dispatchEvent(new PopStateEvent('popstate'));
        } else {
            history.push('/applicationError');
            window.dispatchEvent(new PopStateEvent('popstate'));
        }
    };

    return (
        <>
            <FormHeader
                label={'NSW Seniors Card or NSW Senior Savers Card marketing preferences'}
                title={'Manage your marketing preferences'}
            />
            <ContentContainer className={styles['content-container']}>
                <Row>
                    <Col span={8}>
                        <SectionPage>
                            <p>To check or change your email or postal address go to <a href={process.env.REACT_APP_PERSONAL_DETAILS}>‘Personal details’</a> in your MyServiceNSW Account.</p>

                            <Heading
                                className={styles['newsletter-heading']}
                                level={2}> Seniors Card email newsletter</Heading>
                            <p>Receive a monthly digital newsletter to keep you informed about offers, competitions, activities, and events. We will send it to your MyServiceNSW Account email address.</p>
                            <Field
                                className={styles['newsletter-field']}
                                label='Would you like to receive the Seniors Card email newsletter?'
                                id='newsletter'
                            >
                                <RadioButtonList
                                    id='newsletterRadio'
                                    name='newsletterRadio'
                                    vertical={true}
                                    options={[
                                        { value: 'true', label: 'Yes' },
                                        { value: 'false', label: 'No' },
                                    ]}
                                    onChange={(val) => setNewsletter(val)}
                                    value={newsletter}
                                />
                            </Field>
                            <Heading
                                className={styles['notification-heading']}
                                level={2}>Notifications about exclusive offers</Heading>
                            <Field
                                label='Would you like to be informed about exclusive Seniors Card discounts and offers?'
                                id='ex4'
                                className={styles['spec-offers-field']}
                            >
                                <RadioButtonList
                                    id='specOffersRadio'
                                    name='specOffersRadio'
                                    legend=''
                                    vertical={true}
                                    options={[
                                        { value: 'email', label: 'Yes, by email only' },
                                        { value: 'both', label: 'Yes, by email and mail' },
                                        { value: 'none', label: 'No' },
                                    ]}
                                    onChange={(val) => {
                                        val === 'none' ? loadInitial() : setShow(true);
                                        setSpecOffer(val);
                                    }}
                                    value={specOffer}
                                    errorMessage="Please select one option"
                                    hasError={hasError}
                                />
                            </Field>
                            {specOffer != "none" && show &&
                                <>
                                    <Heading
                                        className={styles['more-offer-heading']}
                                        level={3}>  Want to receive offers more relevant to you? (Optional)</Heading>
                                    <p>If you provide more details about yourself, we can send you information more relevant to you. For example, if you answer that you receive a full pension, we can notify you about offers and events only available to full pension holders.</p>
                                    <p>This information will be shared with the Department of Communities and Justice, who manages the NSW Seniors Card Program and newsletters.</p>
                                    <p>These details are also used in a de-identified way to better understand Seniors Card members and improve the program.</p>

                                    <Field id='ex1'
                                        className={styles['language-field']}
                                        label='What is the main language spoken at home? (Optional)' errorMessage='Select a venue.'>
                                        <Select options={languageList}
                                            placeholder="Select language"
                                            onChange={(e) => setLanguage(e.target.value)}
                                            value={language}
                                        />
                                    </Field>

                                    <RadioButtonList
                                        id='gender'
                                        name='Gender'
                                        legend='What is your gender?'
                                        vertical={true}
                                        options={[
                                            { value: 'Male', label: 'Male' },
                                            { value: 'Female', label: 'Female' },
                                            { value: 'Other', label: 'Other' },
                                            { value: '', label: 'Prefer not to answer' },
                                        ]}
                                        onChange={(val) => setGender(val)}
                                        value={gender}
                                        className={styles['gender-field']}
                                    />

                                    <RadioButtonList
                                        id='pension'
                                        name='Pension'
                                        legend='What is your pension status?'
                                        vertical={true}
                                        options={[
                                            { value: 'Full Pension', label: 'Full Pension' },
                                            { value: 'Part Pension', label: 'Part Pension' },
                                            { value: 'Fully Self Funded', label: "I don't receive a pension" },
                                            { value: '', label: 'Prefer not to answer' },
                                        ]}
                                        onChange={(val) => setPension(val)}
                                        value={pension}
                                        className={styles['additional-details-field']}
                                    />

                                    <RadioButtonList
                                        id='aboriginal'
                                        name='Aboriginal'
                                        legend='Are you Aboriginal and/or Torres Strait Islander?'
                                        vertical={true}
                                        options={[
                                            { value: 'true', label: 'Yes' },
                                            { value: 'false', label: 'No' },
                                            { value: '', label: 'Prefer not to answer' },
                                        ]}
                                        onChange={(val) => setIsAboriginal(val)}
                                        value={isAboriginal}
                                        className={styles['additional-details-field']}
                                    />
                                </>}


                        </SectionPage>
                    </Col>
                </Row>
                <Row>
                    <Col span={6}>
                        <Button
                            className={styles['save']}
                            variant='primary'
                            onClick={onSubmitChange()}>
                            Save
                        </Button>
                        <Button
                            className={styles['do-not-save']}
                            variant='secondary'
                            onClick={() => window.location.href = process.env.REACT_APP_SENIORS_DASHBOARD_URL}>
                            Do not save
                        </Button>
                    </Col>
                </Row>
            </ContentContainer>
            {
                showSpinner && (<ComponentLoader fullPage />)
            }
        </>
    );
};

export default ChangeMarketingDetailsPage;
